// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__pDtJe"};